import { Skeleton } from "@/components/ui/baseUi/skeleton"
import { cn } from "@/modules/lib/utils"
import { HuAvatarCardSidebarSkeleton } from "@/modules/ui/components/huAvatarCardSidebarSkeleton"

export function MemberDetailsSkeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div className={cn("flex flex-col gap-8", className)} {...props}>
      <HuAvatarCardSidebarSkeleton />
      <Skeleton className="mx-auto h-145 w-9/10 rounded-xl" />
    </div>
  )
}
